interface StatMetricProps {
  label: string;
  value: string | number;
  valueColorClass: string;
  unit?: string;
  hasDivider?: boolean;
}

export const StatMetric = ({
  label,
  value,
  valueColorClass,
  unit,
  hasDivider = false,
}: StatMetricProps) => {
  return (
    <div
      className={`flex flex-col items-center flex-1 ${
        hasDivider ? 'border-l border-gray-200 pl-2' : ''
      }`}
    >
      <div className='h-8 flex items-center justify-center text-center'>
        <span className='text-[10px] text-gray-400 font-bold uppercase leading-tight'>
          {label}
        </span>
      </div>
      <div className='flex items-baseline gap-0.5'>
        <span className={`${valueColorClass} font-black leading-none text-2xl`}>
          {value}
        </span>
        {unit && (
          <span className='text-[10px] font-bold text-gray-400 uppercase'>
            {unit}
          </span>
        )}
      </div>
    </div>
  );
};
